import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import {
  FitFontSizeOptions,
  WELCOME_BUTTON_LABEL_FIT,
  WELCOME_CARD_TITLE_FIT,
  WELCOME_HEADLINE_FIT,
} from './welcome-text-utils';
import {
  getWelcomeContentLayout,
  getWelcomeHeroLayout,
  getWelcomeTextWidth,
  WelcomeContentLayout,
  WelcomeHeroLayout,
} from './welcome-responsive';

function scaleFitOptions(
  options: FitFontSizeOptions,
  widthScale: number
): FitFontSizeOptions {
  return {
    charWidthRatio: options.charWidthRatio,
    min: Math.max(8, Math.round(options.min * widthScale)),
    max: Math.max(10, Math.round(options.max * widthScale)),
  };
}

export interface WelcomeResponsiveLayout {
  hero: WelcomeHeroLayout;
  content: WelcomeContentLayout;
  textWidth: number;
  headlineFit: FitFontSizeOptions;
  cardTitleFit: FitFontSizeOptions;
  buttonLabelFit: FitFontSizeOptions;
}

export function useWelcomeResponsiveLayout(): WelcomeResponsiveLayout {
  const { width, height } = useWindowDimensions();

  return useMemo(() => {
    const content = getWelcomeContentLayout(width, height);
    const hero = getWelcomeHeroLayout(width, height);
    const textWidth = getWelcomeTextWidth(width);

    return {
      hero,
      content,
      textWidth,
      headlineFit: scaleFitOptions(WELCOME_HEADLINE_FIT, content.widthScale),
      cardTitleFit: scaleFitOptions(WELCOME_CARD_TITLE_FIT, content.widthScale),
      buttonLabelFit: scaleFitOptions(
        WELCOME_BUTTON_LABEL_FIT,
        content.widthScale
      ),
    };
  }, [width, height]);
}
